import React from 'react'
import {
  Box,
  Heading,
  Text,
  UnorderedList,
  // ListItem,
} from '@chakra-ui/react'
import ReactMarkdown from 'react-markdown'

const markdownComponents = {
  h1: ({ ...props }) => <Heading as="h1" {...props} />,
  h2: ({ ...props }) => <Heading as="h2" fontSize="24px" {...props} />,
  h3: ({ ...props }) => <Heading as="h3" fontSize="20px" {...props} />,
  blockquote: ({ ...props }) => <Box as="blockquote" bg="rgba(45, 84, 232, 0.04)" p="small" display="inline-flex" {...props} />,
  ul: ({ ...props }) => <UnorderedList {...props} />,
  // li: ({ ...props }) => <ListItem {...props} />,
  hr: ({ ...props }) => <Box as="hr" {...props} mb="small" mt="large" />,
  p: ({ ...props }) => <Text {...props} lineHeight="22px" />
}


export interface MarkdownRendererProps {
  children: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ children }) => {
  return (
    <Box whiteSpace="pre-wrap" lineHeight="16px">
      <ReactMarkdown components={markdownComponents}>
        {children}
      </ReactMarkdown>
    </Box>
  )
}